import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const MRIIRSOnboardingModal = () => {
  const { user, isAuthenticated } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState('question'); // question | reward
  const [isClaiming, setIsClaiming] = useState(false);

  useEffect(() => {
    const pending = localStorage.getItem('first_login_onboarding_pending') === '1';
    if (pending && isAuthenticated() && user && user.role !== 'ADMIN' && !user.mriirsStudentConfirmed) {
      setIsOpen(true);
    }
  }, [user, isAuthenticated]);

  const closeModal = () => {
    localStorage.removeItem('first_login_onboarding_pending');
    localStorage.setItem('first_login_onboarding_done', '1');
    setIsOpen(false);
  };

  const handleNotMRIIRS = () => {
    closeModal();
  };

  const handleMRIIRSYes = async () => {
    try {
      setIsClaiming(true);
      await api.post('/api/users/me/mriirs-claim');
      setStep('reward');
    } catch (error) {
      console.error('Failed to claim MRIIRS reward:', error);
      closeModal();
    } finally {
      setIsClaiming(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(15, 23, 42, 0.7)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '18px',
        maxWidth: '560px',
        width: '100%',
        overflow: 'hidden',
        boxShadow: '0 30px 80px rgba(0,0,0,0.35)',
        border: '1px solid rgba(255,255,255,0.1)'
      }}>
        {step === 'question' && (
          <>
            <div style={{
              background: 'linear-gradient(135deg, #7c3aed, #6366f1)',
              color: 'white',
              padding: '20px 24px'
            }}>
              <h3 style={{ margin: 0, fontSize: '20px' }}>🎓 Are you an MRIIRS student?</h3>
              <p style={{ margin: '8px 0 0 0', opacity: 0.9 }}>
                Help us personalize your interview practice experience.
              </p>
            </div>
            <div style={{ padding: '20px 24px' }}>
              <p style={{ margin: 0, color: '#374151' }}>
                Select your answer below to continue.
              </p>
              <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button
                onClick={handleMRIIRSYes}
                disabled={isClaiming}
                style={{
                  background: 'linear-gradient(90deg, #7c3aed, #6366f1)',
                  color: 'white',
                  border: 'none',
                  padding: '10px 18px',
                  borderRadius: '10px',
                  fontWeight: 600,
                  cursor: isClaiming ? 'not-allowed' : 'pointer'
                }}
              >
                {isClaiming ? 'Applying...' : 'Yes, I am'}
              </button>
              <button
                onClick={handleNotMRIIRS}
                style={{
                  background: 'white',
                  border: '1px solid #e5e7eb',
                  padding: '10px 18px',
                  borderRadius: '10px',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                No
              </button>
            </div>
            </div>
          </>
        )}

        {step === 'reward' && (
          <>
            <div style={{
              background: 'linear-gradient(135deg, #0ea5e9, #22c55e)',
              color: 'white',
              padding: '20px 24px'
            }}>
              <h3 style={{ margin: 0, fontSize: '20px' }}>🎉 Reward unlocked</h3>
              <p style={{ margin: '8px 0 0 0', opacity: 0.95 }}>
                You now have 2 mock interviews free.
              </p>
            </div>
            <div style={{ padding: '20px 24px' }}>
              <p style={{ margin: 0, color: '#374151' }}>
                You can start practicing now with your free interviews.
              </p>
              <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                <button
                  onClick={closeModal}
                  style={{
                    background: 'linear-gradient(90deg, #7c3aed, #6366f1)',
                    color: 'white',
                    border: 'none',
                    padding: '10px 18px',
                    borderRadius: '10px',
                    fontWeight: 600,
                    cursor: 'pointer'
                  }}
                >
                  Start practicing
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MRIIRSOnboardingModal;
